<template>
  <v-layout row wrap fill-height v-if="optimizationSummary">
    <v-flex>
      <v-card flat color="transparent">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <p class="text-xs-right subheading">Cena celkom:</p>
              <p class="text-xs-right subheading">{{ customComa() }} € bez DPH</p>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "Cutting",
  props: ["optimizationSummary"],
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    customComa() {
      return this.optimizationSummary.finalPrice.toString().replace(".", ",");
    }
  }
};
</script>

<style>
</style>